// extracted by mini-css-extract-plugin
export default {"deletion":"DeleteAccount_deletion__OnnKS","input":"DeleteAccount_input__SjtSA"};